import { makeStyles } from "tss-react/mui";
import { GlobalSearchInputSize } from "./GlobalSearchInput.types.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function GlobalSearchInput_styles_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else GlobalSearchInput_styles_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const sizeScheme = (tokens)=>({
        [GlobalSearchInputSize.large]: {
            fontSize: tokens.typography.variant.body2.fontSize,
            lineHeight: 1,
            height: '24px',
            paddingBlock: tokens.spacing['16']
        },
        [GlobalSearchInputSize.medium]: {
            fontSize: tokens.typography.variant.body2.fontSize,
            lineHeight: 1,
            height: '24px',
            paddingBlock: tokens.spacing['8']
        }
    });
const useStyles = makeStyles()(({ tokens, px }, { size })=>({
        globalSearchInputFrom: {
            width: '100%',
            position: 'relative'
        },
        globalSearchInputRoot: {
            borderRadius: tokens.radius.m,
            background: tokens.colors.bg.light.primary,
            border: `1px solid ${tokens.colors.stroke.primary}`,
            '&.MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                    borderWidth: `${tokens.border.s}px`
                }
            }
        },
        globalSearchInput: _object_spread_props(_object_spread({}, sizeScheme(tokens)[size]), {
            paddingLeft: tokens.spacing['32'],
            paddingRight: tokens.spacing['32']
        }),
        notchedOutline: {
            borderWidth: 0
        },
        button: {
            '&&': {
                position: 'absolute',
                top: 0,
                right: 0,
                width: `${px(35)}px !important`,
                height: `${px(35)}px !important`
            }
        },
        helperText: {
            marginLeft: 0,
            marginRight: 0
        }
    }));
export { useStyles };
